import Cookies from 'js-cookie';
import * as qs from 'query-string';
import isEmpty from 'lodash/isEmpty';

import isBrowser from './isBrowser';

const withCookieParams = (href: string, cookies?: string[]): string => {
  const defaultCookies = ['userInAbmCampaign'];
  let urlParams = {};
  let urlFragmentIdentifier: string | undefined = '';
  const linkValues = qs.parseUrl(href || '', { parseFragmentIdentifier: true });
  const allCookies = [...defaultCookies, ...cookies!];

  if (isBrowser()) {
    const { search } = window.location;
    const urlQueryParams = qs.parse(search);
    urlParams = { ...linkValues?.query, ...urlQueryParams };
    urlFragmentIdentifier = linkValues?.fragmentIdentifier;
  }

  const setCookies = allCookies.reduce((previous, cookie) => {
    const cookieValue = Cookies.get(cookie);
    if (cookieValue) {
      return {
        ...previous,
        [cookie]: Cookies.get(cookie)
      };
    }

    return previous;
  }, {});

  const allUrlParams = { ...setCookies, ...urlParams };
  return `${linkValues?.url}${!isEmpty(allUrlParams) ? `?${qs.stringify(allUrlParams)}` : ''}${urlFragmentIdentifier ? `#${urlFragmentIdentifier}` : ''}`;
};

export default withCookieParams;
